import React from 'react';
import cx from "classnames";

const AFErrorDialog = () => {
    const refreshPage = () => {
        window.location.reload();
    };

    return (
        <div className={cx("banner-notification banner-notification-error")}>
            <span className={cx("text-banner-error banner-notification-error-text")}>
                Oops, something doesn't seem right.
            </span>
            <button
                className={cx("btn-secondary")}
                onClick={refreshPage}
            >
                Try again
            </button>
        </div>
    );
};

export default AFErrorDialog;